import { SceneContainer } from "GameObjects/StoryGame/SceneContainer";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, RoughEase, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch6_p16 } from "../../../layouts/ch6_p16/ch6_p16";

export class Chapter6Page16 extends AbstractStoryState implements ReturnType<typeof ch6_p16> {

    readonly bg = this.addChild(new SceneSprite());
    readonly lettersContainer = this.addChild(new SceneContainer());
    readonly letters = list(()=>this.lettersContainer.addChild(SceneSprite.withPrefix("ch6_p16/")));

    readonly handPhone = this.addChild(new SceneSprite());
    readonly holly = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly tyler = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly rain = [this.addChild(SceneSprite.withPrefix("ch6_p16/")), this.addChild(SceneSprite.withPrefix("ch6_p16/"))];

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch6_p16/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch6_p16/"));

    readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch6_p16/"));
    readonly linesRight = this.addChild(SceneSprite.withPrefix("ch6_p16/"));

    dontScaleUp = true;
    protected lettersTimeline?: TimelineMax;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch6_p16.call(this);

        this.holly[1].visible = false;
        this.tyler[1].visible = false;
        this.handPhone.visible = false;

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);

        this.lettersTimeline = new TimelineMax();
		this.lettersTimeline
			.to(this.letters, 1, {pixi: {
				scale: this.letters[0].scale.x * 1.1,
			}, ease: new RoughEase({
				taper: 'none',
				points: 200,
				strength: 2,
				randomize: false,
			})});
		this.lettersTimeline.repeat(-1).repeatDelay(1);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public destroy() {
        super.destroy();
        this.lettersTimeline?.kill();
    }

    public onAnimateInComplete() {
        new TimelineLite()
            .call(()=>{
                this.holly[0].FadeOut();
                this.tyler[0].FadeOut();
                this.lettersContainer.FadeOut();

                this.holly[1].FadeIn();
                this.tyler[1].FadeIn();
                this.handPhone.visible = true;
            })
            .from(this.handPhone, 1.5, {pixi: {angle: 90}})
            .call(()=>{
                super.onAnimateInComplete();
            })
            .call(()=>{
                this.gotoNextState({transition: "left"});
            }, undefined, undefined, "+=1.5");
    }

}